import { useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { StatsModuleProps, Stats } from "@/patterns/adg4/stats/src/stats";

export const TeamStats = () => {
    const intl = useIntl();

    const statsProps: StatsModuleProps = {
        headerText: intl.formatMessage({
            id: "HomePageTemplateV2.teamStatsHeader",
            defaultMessage: "Teams across the globe run on Atlassian"
        }),
        bigStat: {
            stat: "300000",
            statText: intl.formatMessage({
                id: "HomePageTemplateV2.teamStatsCompaniesTxt",
                defaultMessage:
                    "companies power team collaboration with Atlassian"
            }),
            statColor: "#1868DB",
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: "#1868DB"
            }
        },
        littleStats: [
            {
                stat: "200",
                statText: intl.formatMessage({
                    id: "HomePageTemplateV2.teamStatsPeopleTxt",
                    defaultMessage:
                        "countries have companies that use Atlassian"
                }),
                statColor: "#1868DB",
                statSymbol: {
                    symbolCharacter: "+",
                    symbolCharacterColor: "#1868DB"
                }
            },
            {
                stat: "80",
                statText: intl.formatMessage({
                    id: "HomePageTemplateV2.teamStatsFortune500Txt",
                    defaultMessage:
                        "of Fortune 500 companies use Atlassian products"
                }),
                statColor: "#1868DB",
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: "#1868DB"
                }
            }
        ]
    };

    return (
        <UFOSegment name="homepage-v2-stats">
            <section>
                <Stats {...statsProps} />
            </section>
        </UFOSegment>
    );
};
